import { Component, inject, input, output } from '@angular/core';
import { MILESTONE_STATUS } from '@program/shared/milestone-status.enum';
import { Milestone } from '@project/detail/milestones/milestone.model';
import { MilestoneStatus } from '@project/detail/milestones/milestone-status.model';
import { MilestonePermissionsService } from '@shared/services/milestone-permissions.service';
import { Project } from '@project/shared/project.model';

@Component({
  selector: 'oes-milestone-status-dropdown',
  templateUrl: './milestone-status-dropdown.component.html',
  styleUrls: ['./milestone-status-dropdown.component.scss'],
  providers: [MilestonePermissionsService]
})
export class MilestoneStatusDropdownComponent {
  milestone = input.required<Milestone>();
  milestoneStatus = input.required<MilestoneStatus>();
  initialStatusSelection = input.required<any[]>();
  statusDropdownOptions = input.required<any[]>();
  project = input.required<Project>();

  statusChanged = output();

  public milestonePermissionsService = inject(MilestonePermissionsService);

  stopPropagation(event) {
    event.stopPropagation();
  }

  get shouldHighlightMilestone() {
    return this.milestonePermissionsService.shouldHighlightMilestone(this.milestone());
  }

  get dropdownColor() {
    if (this.shouldHighlightMilestone) {
      return ['color-highlighted'];
    }

    return [`color-${this.milestoneStatus()?.color}`];
  }

  get mapStatusToClass(): string {
    if (this.shouldHighlightMilestone) {
      return 'highlighted';
    }

    switch (this.initialStatusSelection()?.[0]?.value) {
      case MILESTONE_STATUS.IN_PROGRESS:
        return 'in-progress';
      case MILESTONE_STATUS.COMPLETED:
        return 'completed';
      case MILESTONE_STATUS.NOT_STARTED:
        return 'not-started';
      default:
        return '';
    }
  }
}
